module.exports = __webpack_public_path__ + "media/images/emblems/Domat_Ems_wappen-4fc59ed7e909162162cc239c6f09dbd3.svg";